import { render, staticRenderFns } from "./RemovalClaims.vue?vue&type=template&id=281fe753"
import script from "./RemovalClaims.vue?vue&type=script&lang=js"
export * from "./RemovalClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports